import { render } from "./ClickableText.vue?vue&type=template&id=d47e8470&scoped=true"
import script from "./ClickableText.vue?vue&type=script&lang=js"
export * from "./ClickableText.vue?vue&type=script&lang=js"

import "./ClickableText.vue?vue&type=style&index=0&id=d47e8470&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d47e8470"]])

export default __exports__